import t from 'common/i18n';
import './UploadPresetInput.scss';
import { ComboboxItem } from '@cld/combobox';
import { ItemLayout } from '@clds/item';
import { Info } from '@clds/icon';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { StyledSimpleValueComboboxField } from '../../../common/combobox.jsx';

const convertOptionsToValues = (options) => {
  return options.reduce((newValues, option) => {
    if (option !== '') {
      newValues.push({ value: option, label: option });
    }
    return newValues;
  }, []);
};

const NoOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.xxs};
  padding: ${(props) => props.theme.spacing.xxs};
`;

const NoOptions = ({ inputValue }) => {
  return (
    <NoOptionsContainer>
      <Info size="md" color="error" />
      {`${t('advanced_options.upload_preset_no_options')} ${inputValue ? `: '${inputValue}'` : ''} `}
    </NoOptionsContainer>
  );
};

const UploadPresetInput = ({ options, onChange, value }) => {
  const Option = (props) => (
    <ComboboxItem {...props}>
      <ItemLayout>{props.data.label}</ItemLayout>
    </ComboboxItem>
  );

  const components = {
    DropdownIndicator: null,
    NoOptionsMessage: ({ selectProps }) => <NoOptions inputValue={selectProps.inputValue} />,
    Option,
  };

  const presetOptions = convertOptionsToValues([...options]);

  return (
    <StyledSimpleValueComboboxField
      menuPlacement="top"
      size={'md'}
      components={components}
      options={presetOptions}
      isSearchable
      isClearable
      onChange={onChange}
      placeholder={t('advanced_options.upload_preset_placeholder')}
      value={value ? value : undefined}
    />
  );
};

export default UploadPresetInput;
